const subTypes = {
    email: 'E-mail',
    fb: 'Facebook',
    tm: 'Telemarketing'
};

export default {
    audience: 1,
    journey: 2,
    touchpoint: 3,
    //goal: 4,
    audienceFilter: 5
};

export {
    subTypes
};